"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../utils/constants");
const analyticsUtils_1 = require("../../utils/analyticsUtils");
const partners_1 = require("../../utils/partners");
const navigation_1 = require("../../interfaces/navigation");
const config = {
    nodes: [
        {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: navigation_1.AnalyticsActionHeaderType.Buy,
            path: `/${constants_1.Pages.SearchResultsPage}`,
            text: navigation_1.NavigationType.Buy,
            type: navigation_1.NavigationType.Buy,
            sections: [
                {
                    text: 'Buy',
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Buy,
                    path: `/${constants_1.Pages.SearchResultsPage}`,
                    type: navigation_1.NavigationType.GenericLink,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: `/${constants_1.Pages.SearchResultsPage}`,
                            text: 'Search used cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/used-cars',
                            text: 'Browse used cars',
                            type: navigation_1.NavigationType.GenericLink,
                            hideDesktop: true,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/account/edituser',
                            text: 'My classifieds account',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/account/bookmarks',
                            text: 'My favourites',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/account/savedsearches',
                            text: 'My saved searches',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: 'https://pistonheads.shop',
                            text: 'Merchandise',
                            isOpenInNewWindow: true,
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Buy,
                    text: 'Browse',
                    path: '/classifieds/used-cars',
                    type: navigation_1.NavigationType.GenericLink,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/used-cars',
                            text: 'Used cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/motorsport',
                            text: 'Motorsport',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/motorbikes',
                            text: 'Motorbikes',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/big-stuff',
                            text: 'Big stuff',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/parts-and-plates',
                            text: 'Parts & plates',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Buy,
                            path: '/classifieds/non-motoring',
                            text: 'Non-motoring',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
        {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: navigation_1.AnalyticsActionHeaderType.Sell,
            path: '/sell-my-car',
            text: navigation_1.NavigationType.Sell,
            type: navigation_1.NavigationType.Sell,
            sections: [
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Sell,
                    text: 'Selling',
                    path: '/sell-my-car',
                    type: navigation_1.NavigationType.SellingOptions,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Sell,
                            path: '/sell-my-car',
                            text: 'Sell my car',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Sell,
                            path: '/account/edituser',
                            text: 'My classifieds account',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Sell,
                            path: '/account/myadverts',
                            text: 'My adverts',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
        {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: navigation_1.AnalyticsActionHeaderType.News,
            path: '/news',
            text: navigation_1.NavigationType.News,
            type: navigation_1.NavigationType.News,
            sections: [
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.News,
                    text: navigation_1.NewsType.News,
                    path: '/news',
                    type: navigation_1.NavigationType.News,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/search.asp',
                            text: 'Search news',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/general-pistonheads',
                            text: 'General news',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/ph-americancars',
                            text: 'American cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/ph-britishcars',
                            text: 'British cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/ph-eurocars',
                            text: 'Euro cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/ph-germancars',
                            text: 'German cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/ph-japanesecars',
                            text: 'Japanese cars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/news/electric-vehicles',
                            text: 'Electric vehicles',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.News,
                    text: navigation_1.NewsType.Regulars,
                    type: navigation_1.NavigationType.Regulars,
                    path: '/regulars',
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/regulars/ph-features-sheds',
                            text: 'Shed of the week',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/regulars/ph-spottedykywt',
                            text: 'Spotted',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/regulars/ph-fleet',
                            text: 'PH fleet',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/road-tests',
                            text: 'Road tests',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/features/ph-features-heroes',
                            text: 'PH heroes',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.News,
                            path: '/features/ph-buying-guides',
                            text: 'PH buying guides',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
        {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: navigation_1.AnalyticsActionHeaderType.Forums,
            path: '/gassing/',
            text: navigation_1.NavigationType.Forums,
            type: navigation_1.NavigationType.Forums,
            sections: [
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Forums,
                    text: 'Forums',
                    path: '/gassing/',
                    type: navigation_1.NavigationType.Forums,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/search',
                            text: 'Search forums',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/whatsnew.asp?h=0',
                            text: "What's new",
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forum.asp?h=0&f=23',
                            text: 'General gassing',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forumgroup.asp?c=10',
                            text: 'Motorsport',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/news/ph-general/pistonheads-events/45926',
                            text: 'Events',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forumgroup.asp?c=41',
                            text: 'The Pie & Piston',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forumgroup.asp?c=98',
                            text: 'Supercars',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forumgroup.asp?c=39',
                            text: 'Porsche',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forumgroup.asp?c=3',
                            text: 'TVR',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/forum.asp?h=0&f=210',
                            text: 'The Lounge',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Forums,
                    text: 'My account',
                    type: navigation_1.NavigationType.MyAccount,
                    path: '/members/editProfile.asp',
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/members/mycars.asp',
                            text: 'My garage',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/mytopics.asp?h=0',
                            text: 'My stuff',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/gassing/prefs.asp?h=0',
                            text: 'My preferences',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/members/editProfile.asp',
                            text: 'My profile',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Forums,
                            path: '/members/mates.asp',
                            text: 'My mates',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
        {
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            action: navigation_1.AnalyticsActionHeaderType.Events,
            path: '/news/ph-general/pistonheads-events/45926',
            text: navigation_1.NavigationType.Events,
            type: navigation_1.NavigationType.Events,
            sections: [
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Events,
                    text: '',
                    path: '/',
                    type: navigation_1.NavigationType.MoreEvents,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Events,
                            path: '/calendar',
                            text: 'Calendar',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Events,
                            path: '/calendar/phevents.asp',
                            text: 'PH events',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Events,
                            path: '/news/ph-general/pistonheads-at-le-mans/45927',
                            text: 'Le Mans',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
        {
            action: navigation_1.AnalyticsActionHeaderType.Services,
            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
            path: '/',
            text: navigation_1.NavigationType.Services,
            type: navigation_1.NavigationType.Services,
            sections: [
                {
                    category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                    action: navigation_1.AnalyticsActionHeaderType.Services,
                    text: '',
                    path: '/',
                    type: navigation_1.NavigationType.ServicesTools,
                    sections: [
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Services,
                            path: partners_1.financeUrlUnder30k,
                            rel: 'sponsored',
                            text: 'Car finance under £30K',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Services,
                            path: partners_1.financeUrlAbove30k,
                            rel: 'sponsored',
                            text: 'Car finance above £30K',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Services,
                            path: partners_1.insuranceUrl,
                            rel: 'sponsored',
                            text: 'Car insurance',
                            type: navigation_1.NavigationType.GenericLink,
                        },
                        {
                            category: analyticsUtils_1.AnalyticsCategoryType.Navigation,
                            action: navigation_1.AnalyticsActionHeaderType.Services,
                            path: partners_1.gapInsuranceUrl,
                            rel: 'sponsored',
                            text: 'Gap insurance',
                            isOpenInNewWindow: true,
                            type: navigation_1.NavigationType.GenericLink,
                        },
                    ],
                },
            ],
        },
    ],
};
exports.default = config;
//# sourceMappingURL=config.js.map